import React from 'react';
import './TeachersSection.css';
import lukaszPhoto from '../assets/images/lukasz2.png';
import kornelPhoto from '../assets/images/kornel.png';

interface Stat {
  value: string;
  label: string;
}

interface Founder {
  name: string;
  role: string;
  description: string;
  achievements: string[];
  photo: string;
  stats: Stat[];
}

const TeachersSection: React.FC = () => {
  const founders: Founder[] = [
    {
      name: "Łukasz",
      role: "Współzałożyciel • Opiekun ucznia",
      description: "Wierzę, że każdy może zrozumieć matematykę. Moja misja to przekształcać obawy w pewność siebie i sukcesy.",
      achievements: [
        "Opracował unikalne metody nauczania matematyki oparte na relacji ucznia z tutorem (GIFE)",
  "Pasjonat fińskiego modelu nauczania i całego podejścia do edukacji",
        "Stały kontakt z uczniami i rodzicami"
      ],
      photo: lukaszPhoto,
      stats: [
        { value: "100%", label: "zdawalność" },
        { value: "5+", label: "lat doświadczenia" }
      ]
    },
    {
      name: "Kornel",
      role: "Współzałożyciel • Opiekun olimpijski",
      description: "Matematyka to moja pasja. Dobrze ją rozumiejąc, potrafisz lepiej rozumieć rzeczywistość — również tę niematematyczną.",
      achievements: [
        "Wielokrotny finalista Olimpiady Matematycznej",
        "Zwycięzca XIII Olimpiady Matematycznej Juniorów",
        "Trzykrotny mistrz Polski w Geometrii Elementarnej",
        "Przygotowuje laureatów konkursów",
        "Dba o kwestie merytoryczne w Sigma Study"
      ],
      photo: kornelPhoto,
      stats: [
        { value: "3x", label: "mistrz Polski w geometrii" },
        { value: "10+", label: "laureatów w konkursach" }
      ]
    }
  ];

  return (
    <section id="teachers" className="teachers-section">
      <div className="teachers-container">
        <div className="teachers-header">
          <span className="teachers-badge">O nas</span>
          <h2>Założyciele Sigma Study</h2>
          <p>Poznaj osoby, których podejście zmieni Twoje wyniki</p>
        </div>

        <div className="founders-grid">
          {founders.map((founder, index) => (
            <div key={index} className={`founder-card founder-${index === 0 ? 'lukasz' : 'kornel'}`}>
              <div className="founder-card-inner">
                <div className="founder-photo-wrapper">
                  <img
                    src={founder.photo}
                    alt={founder.name}
                    className={`founder-photo founder-photo-${index === 0 ? 'lukasz' : 'kornel'}`}
                    loading="eager"
                  />
                </div>

                <div className="founder-content">
                  <h3 className="founder-name">{founder.name}</h3>
                  <p className="founder-role">{founder.role}</p>

                  <blockquote className="founder-quote">
                    "{founder.description}"
                  </blockquote>

                  <div className="founder-achievements">
                    <h4>Osiągnięcia</h4>
                    <ul>
                      {founder.achievements.map((achievement, idx) => (
                        <li key={idx}>{achievement}</li>
                      ))}
                    </ul>
                  </div>

                  <div className="founder-stats">
                    {founder.stats.map((stat, idx) => (
                      <div key={idx} className="founder-stat">
                        <span className="founder-stat-value">{stat.value}</span>
                        <span className="founder-stat-label">{stat.label}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="founder-glow"></div>
            </div>
          ))}
        </div>

        <div className="teachers-cta">
          <button
            className="teachers-cta-button"
            onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
          >
            Zapisz się na zajęcia
          </button>
        </div>
      </div>
    </section>
  );
};

export default TeachersSection;
